import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import get from 'lodash/get';

import colors from '@app/constants/colors';
import { Loader } from '@app/components';
import { resetPayments, checkPaymentStatus } from '@app/actions/paymentActions';
import { subscriptionStatus } from '@app/constants/subscribe';
import { SuccessfulPayment, PaymentError } from './PaymentResultsMessages';

class PaymentResults extends React.Component {
  componentDidMount() {
    const { checkPaymentStatus, error } = this.props;

    if (!error) {
      checkPaymentStatus();
    }
  }

  componentWillUnmount() {
    const { resetPayments } = this.props;
    resetPayments();
  }

  render() {
    const {
      isPurchaseInProgress, isSubscriptionActive, subscriptionStatusId,
    } = this.props;

    const isPending = subscriptionStatusId === subscriptionStatus.PENDING;
    let headerMessage;

    if (isSubscriptionActive) {
      headerMessage = 'subscribe.success';
    } else if (isPending) {
      headerMessage = 'payment.pending';
    } else {
      headerMessage = 'subscribe.failure';
    }

    return isPurchaseInProgress ? <Loader /> : (
      <PageContainer>
        <Heading>
          <FormattedMessage id={headerMessage} />
        </Heading>
        <GradientBlock>
          {
            isSubscriptionActive || isPending
              ? <SuccessfulPayment isPending={isPending} />
              : <PaymentError />
          }
        </GradientBlock>
      </PageContainer>
    );
  }
}

PaymentResults.propTypes = {
  resetPayments: PropTypes.func.isRequired,
  checkPaymentStatus: PropTypes.func.isRequired,
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
  isPurchaseInProgress: PropTypes.bool.isRequired,
  isSubscriptionActive: PropTypes.bool.isRequired,
  subscriptionStatusId: PropTypes.number.isRequired,
};

PaymentResults.defaultProps = {
  error: null,
};

const mapStateToProps = ({
  payment: { error },
  subscribe: { isPurchaseInProgress, isSubscriptionActive, userOptions },
}) => ({
  error,
  isPurchaseInProgress,
  isSubscriptionActive,
  subscriptionStatusId: get(userOptions, '0.statusId', null),
});
const mapDispatchToProps = { resetPayments, checkPaymentStatus };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentResults));

const PageContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  width: 100%;
  min-height: 300px;
  padding: 20px 0;
`;

const Heading = styled.h2`
  color: ${({ isTextDanger }) => (isTextDanger ? colors.ALIZARIN_CRIMSON : colors.ALICE_BLUE)};
  max-width: 820px;
  margin-bottom: 40px;
`;

const GradientBlock = styled.div`
  background: linear-gradient(0deg,  ${colors.BEESWAX} 0%, ${colors.ENERGY_YELLOW} 100%);
  color: ${colors.INTERNATIONAL_ORANGE};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 40px 0 80px;
  width: 100%;
  height: auto;
  min-height: 300px;
  
  @media (max-width: 979px) {
    padding: 20px 0 40px;
    margin-top: 30px;
  }  
`;
